import type { FC } from "react";
import { Clock, Search, Gem } from "lucide-react";

import type { LawyerPlanKey } from "@/shared/constants/lawyerPlans";

export interface AddonCard {
  key: LawyerPlanKey;
  name: string;
  addOnPrice: number;
  description: string;
  savingsIcon: FC<{ className?: string }>;
  savingsText: string;
}

export const BASE_PLAN = {
  name: "Estate setup",
  price: 500,
  description:
    "Elayne organizes everything the court and your attorney will need, from documents to family details, in one shared record",
  savingsIcon: Clock,
  savingsText: "Save 30 hours on average getting to filing",
} as const;

export const ADDONS: AddonCard[] = [
  {
    key: "asset_discovery",
    name: "Asset search",
    addOnPrice: 2500,
    description:
      "Search beyond public records for financial accounts, insurance policies, benefits, and property families often don't know exist",
    savingsIcon: Search,
    savingsText: "$5M+ found with Elayne Asset Search",
  },
  {
    key: "estate_administration",
    name: "Estate administration",
    addOnPrice: 3000,
    description:
      "Move every asset to the people meant to have it, with the estate account, transfers, and final steps managed in one place",
    savingsIcon: Gem,
    savingsText: "Comparable concierge plans average $14,700",
  },
];

export function toggleAddonSelection(
  prev: Set<LawyerPlanKey>,
  key: LawyerPlanKey,
): Set<LawyerPlanKey> {
  const next = new Set(prev);
  if (next.has(key)) {
    next.delete(key);
    if (key === "estate_administration") {
      next.delete("asset_discovery");
    }
  } else {
    next.add(key);
    if (key === "estate_administration") {
      next.add("asset_discovery");
    }
  }
  return next;
}

export function calculateTotal(basePrice: number, selected: Set<LawyerPlanKey>): number {
  return (
    basePrice +
    ADDONS.reduce((sum, addon) => sum + (selected.has(addon.key) ? addon.addOnPrice : 0), 0)
  );
}
